import { LocalDateTime } from '../../../../features/localDate/DateTimeView';

export interface IOrderRow {
    id: number;
    name: string;
    numberOfImages: number;
    photographerInstructions?: string;
    thumbnails: IImageThumbnail[];
    fileNames: any[];
    orderRowProductProperties: any[];
    failedUploads: any[];
    uploadsInProgress: any[];
    editedPhotosUploadInProgress?: boolean | null;
    changeStatus: { value: number; displayName: string };
}
export interface IImageThumbnailOverrideProperties {
    categoryId: number;
}

export interface ICreateStitchedImageResponse {
    thumbnail: IImageThumbnail;
    fileName: string;
    isCorrectNumberOfImages: boolean;
    currentStatus: number;
    photosInRows: any[];
    canReapprove: boolean;
}

export interface IImageThumbnail {
    id: number;
    sortIndex: number;
    filename: string;
    highResolutionImageReference: string;
    previewReference: string;
    reference: string;
    needsEditing: boolean;
    hasOldNeedsEditing: boolean;
    categoryId: number;
    orderRowName: string;
    orderRowId: number;
    hasComment: boolean;
    hasOldComment: boolean;
    hasUploadedNormal: boolean;
    canDelete: boolean;
    seeNormalIcon: boolean;
    highResolutionWidth: number;
    highResolutionHeight: number;
    hasAutoScale: boolean;
    hasDeliveryConnection: boolean;
    isCustomerApproved: boolean;
    isEdited: number;
    overrideProperties?: IImageThumbnailOverrideProperties;
}

export interface IImageThumbModalViewModel {
    imageShowcaseViewModels: IImage[];
    thumbnail: IImageThumbnail;
}

export interface IComment {
    id: number;
    author: string;
    feature: string;
    text: string;
    time: LocalDateTime;
    toImageEditor: boolean;
    toPhotographer: boolean;
    toSe360: boolean;
    imageId: number;
    show: {
        photographer: boolean;
        imageEditor: boolean;
    };
}

export interface IImage {
    id: number;
    reference: string;
    highResImageReference: string;
    filename: string;
    time: Date;
    commentModel: ICommentModel;
    parentId: number;
    needsEditing: boolean;
    width: number;
    height: number;
    fileSize: number;
    dpi: number;
    category: number;
    normalImageReference: string;
    canDelete: boolean;
    isCustomerApproved: boolean;
    hasComments: boolean;
    thumbnailReference?: string;
    hasDeliveryConnection?: boolean;
    isFavorited?: boolean;
}

export interface ICommentModel {
    role: number;
    comments: IComment[];
}

export interface IFilter {
    photographer: boolean;
    imageEditor: boolean;
    customer: boolean;
    se360: boolean;
}

export interface IImageProcessingComments {
    commentToImageEditor: string;
    commentFromImageEditor: string;
}

export interface IMetadata {
    filename: string;
    imageWidth: number;
    imageHeight: number;
    fileSize: number;
}

export const ImageType = {
    UNEDITED: 0,
    EDITED: 1
};

export const CommentType = {
    TO_IMAGE_EDITOR_FROM_CHAIN: 0,
    TO_IMAGE_EDITOR_FROM_FIRM: 1,
    FROM_IMAGE_EDITOR: 2,
    TO_PHOTOGRAPHER: 3,
    INTERNAL: 4,
    FROM_PHOTOGRAPHER: 5,
    FROM_PHOTOGRAPHER_TO_EDITOR: 6,
    DELIVERY_WARNING: 7,
    FROM_AGENT_TO_PHOTOGRAPHER: 8,
    ORDER_INTERNAL_COMMENT: 9
};

export const Category = {
    NORMAL: 1,
    EXTRA: 2,
    EJLEV: 3
};

export enum Resolution {
    Normal = 'normal',
    High = 'high'
}
